export default __webpack_public_path__ + "static/media/DeliveryTypeIcon.6e49b9f6.svg";